/* eslint-disable perfectionist/sort-objects */
import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
	base: {
		colorPalette: 'primary',
		_disabled:    { layerStyle: 'disabled' },
	},
	className:       'chakra-button',
	defaultVariants: {
		shape:   'rounded',
		variant: 'solid',
		size:    'lg',
	},
	variants: {
		shape: {
			squared: { borderRadius: '8px', aspectRatio: '1' },
			rounded: { borderRadius: '32px' },
		},
		size: {
			xs: {
				_icon: {
					height: '4',
					width:  '4',
				},
				gap:        '2',
				h:          '8',
				px:         '5',
				fontSize:   '12px',
				lineHeight: 1,
				fontWeight: 'normal',
			},
			sm: {
				_icon: {
					height: '4',
					width:  '4',
				},
				gap:        '2',
				h:          '9',
				px:         '6',
				fontSize:   '14px',
				lineHeight: 1,
				fontWeight: 'normal',
			},
			md: {
				_icon: {
					height: '4.5',
					width:  '4.5',
				},
				gap:        '2',
				h:          '10',
				px:         '7',
				fontSize:   '16px',
				lineHeight: 1,
				fontWeight: 'normal',
			},
			lg: {
				_icon: {
					height: '5',
					width:  '5',
				},
				gap:        '3',
				h:          '12',
				px:         '8',
				fontSize:   '16px',
				lineHeight: 1,
				fontWeight: 'normal',
			},
		},
		variant: {
			outline: {
				_expanded: {
					bg:    'colorPalette.subtle',
					color: 'colorPalette.solid',
				},
				_hover: {
					bg:    'colorPalette.subtle',
					color: 'colorPalette.solid',
				},
				borderColor: 'colorPalette.solid',
				borderWidth: '1px',
				color:       'colorPalette.solid',
			},
			solid: {
				_expanded:   { bg: 'colorPalette.focusRing' },
				_hover:      { bg: 'colorPalette.focusRing' },
				bg:          'colorPalette.solid',
				borderColor: 'transparent',
				color:       'colorPalette.contrast',
			},
			plain: {
				borderWidth: '1px',
				color:       'colorPalette.solid',
				px:          0,
				minW:        'fit-content',
			},
			subtle: {
				_expanded: { bg: 'colorPalette.focusRing' },
				_hover:    {
					bg:    'colorPalette.solid',
					color: 'colorPalette.contrast',
				},
				borderRadius: 'lg',
				bg:           'colorPalette.subtle',
				borderColor:  'colorPalette.solid',
				color:        'colorPalette.solid',
			},
		},
	},
});
